document.addEventListener("DOMContentLoaded", function () {
  
  const tabs = document.querySelectorAll(".filter-tab");
  const articles = document.querySelectorAll(".article-item");
  const sortSelect = document.getElementById("sortSelect");
  const articlesContainer = document.querySelector(".blog-articles");

  let activeTag = "all";

  // Filter by tag
  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");
      activeTag = tab.getAttribute("data-tag");

      filterArticles();
    });
  });

  // Sort by dropdown
  sortSelect.addEventListener("change", function () {
    sortArticles();
    filterArticles();
  });

  function filterArticles() {
    const allArticles = Array.from(articlesContainer.querySelectorAll(".article-item"));

    allArticles.forEach(article => {
      const hasTag = article.classList.contains(`tag-${activeTag}`);
      if (activeTag === "all" || hasTag) {
        article.style.display = "block";
      } else {
        article.style.display = "none";
      }
    });
  }

  function sortArticles() {
    const sortBy = sortSelect.value;
    const allArticles = Array.from(articlesContainer.querySelectorAll(".article-item"));

    allArticles.sort((a, b) => {
      if (sortBy === "newest") return b.dataset.date - a.dataset.date;
      if (sortBy === "oldest") return a.dataset.date - b.dataset.date;
      if (sortBy === "az") return a.dataset.title.localeCompare(b.dataset.title);
      if (sortBy === "za") return b.dataset.title.localeCompare(a.dataset.title);
    });

    allArticles.forEach(article => articlesContainer.appendChild(article));
  }

});

// filter 
 document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelector('.blog-filter-tabs');
    if (tabs) {
      tabs.scrollLeft = 0;
    }
  });